var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Stage',{attrs:{"slides":_vm.stage_images,"showInfo":""}}),_c('b-container',{staticStyle:{"padding":"1em"},attrs:{"fluid":"xl"}},[_c('b-row',{attrs:{"no-gutters":""}},_vm._l((_vm.themes),function(theme){return _c('ThemeContainer',{key:theme.title,attrs:{"themeObject":theme}})}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }